/** Hero: the troupe on the smoky crimson-to-indigo stage. */
export const heroImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/41ed70bc-cd73-46b8-9f4e-5d453fee81ba.jpg'

/** Product mockup: the six spiral volumes fanned out. Used in the pricing card. */
export const productImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/96f281d3-060e-40dd-afd6-a31a6b6051c0.jpg'
